import { useState, type FormEvent } from 'react';
import { api, ApiError, setCsrfToken } from '../api/client';

/**
 * 웹 페어링: 서버 관리 CLI(pair create)로 받은 5분짜리 일회용 코드를 입력한다.
 * 토큰은 JSON으로 받지 않고 HttpOnly 쿠키로만 설정된다.
 */
export function PairingPage({ message, onPaired }: { message?: string; onPaired: () => void }) {
  const [code, setCode] = useState('');
  const [deviceName, setDeviceName] = useState('웹 브라우저');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await api.post<{ data: { csrfToken: string } }>('/pairing/claim', { code, platform: 'web', deviceName });
      setCsrfToken(res.data.csrfToken);
      onPaired();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : '연결하지 못했습니다.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="pairing">
      <form className="card" onSubmit={submit}>
        <p className="brand">▧ 차곡</p>
        <h1>이 브라우저 연결하기</h1>
        <p className="muted">
          서버에서 <code>node build/api/cli.js pair create --label web</code>을 실행해 받은 코드를 입력해주세요. 코드는 5분 동안 한 번만 쓸 수 있습니다.
        </p>
        {message && <p className="notice warn">{message}</p>}
        <label>
          페어링 코드
          <input value={code} onChange={(e) => setCode(e.target.value)} autoComplete="off" autoCapitalize="characters" spellCheck={false} required placeholder="XXXXX-XXXXX-XXXXX-XXXXX-XXXXX-X" />
        </label>
        <label>
          기기 이름
          <input value={deviceName} onChange={(e) => setDeviceName(e.target.value)} maxLength={60} required />
        </label>
        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}
        <button className="primary full save" disabled={busy}>
          {busy ? '연결 중…' : '연결'}
        </button>
      </form>
    </div>
  );
}
